import { InteractionRequiredAuthError, InteractionType } from '@azure/msal-browser';
import { useMsalAuthentication } from '@azure/msal-react';
import { loginRequest, msalInstance } from '../../config/msalConfig';
import { getIsSupplier } from '../../services/access-control-service';
import { useEffect, useState } from 'react';
import { Loader } from '../shared/loader/loader';

const Authenticate = ({ children }) => {
	const { login, error } = useMsalAuthentication(InteractionType.Silent, loginRequest);
	const account = msalInstance.getActiveAccount();
	const accounts = msalInstance.getAllAccounts();
	const [isAccount, setIsAccount] = useState({ accountId: '', isLoading: false });
	// Default to using the first account if no account is active on page load
	if (!account && accounts.length > 0) {
		// Account selection logic is app dependent. Adjust as needed for different use cases.
		msalInstance.setActiveAccount(accounts[0]);
	}
	const localAccountId = account?.localAccountId || '';

	useEffect(() => {
		if (!localAccountId) {
			localStorage.setItem('isSupplierAccount', 'true');
			setIsAccount({ accountId: '', isLoading: false });
			return;
		}
		setIsAccount({ accountId: localAccountId, isLoading: true });

		getIsSupplier(localAccountId)
			.then((isSupplierAccount) => {
				localStorage.setItem('isSupplierAccount', isSupplierAccount?.toString());
			})
			.catch((e) => {
				localStorage.setItem('isSupplierAccount', 'true');
				console.error(e);
			})
			.finally(() => {
				setIsAccount({ accountId: localAccountId, isLoading: false });
			});
	}, [localAccountId]);

	useEffect(() => {
		if (error instanceof InteractionRequiredAuthError) {
			login(InteractionType.Redirect, loginRequest);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [error]);

	if (localAccountId && (isAccount.accountId !== localAccountId || isAccount.isLoading)) {
		return <Loader open={true} message="Loading access..." />;
	}

	return <>{children}</>;
};
export default Authenticate;
